import { createApp } from "vue";
import { createEventBus } from "~/utils/miscellaneous";
import pick from "lodash/pick";

export function createMyApp(...args) {
    const app = createApp(...args);
    const { unmount } = app;

    const eventBus = createEventBus();

    Object.assign(app, {
        ...pick(eventBus, ['$on', '$once', '$off']),
        unmount(...unmountArgs) {
            eventBus.$emit('beforeUnmount');
            unmount.call(app, ...unmountArgs);
            eventBus.$emit('unmounted');
        }
    });

    return app;
}